import { render } from "./App.vue?vue&type=template&id=07356690"
const script = {}

import exportComponent from "/home/runner/work/origins-memo/origins-memo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__